module.exports = __webpack_public_path__ + "assets/92777f409ab28153597f436fd604cb47.png";